import { LogTimeModalFooter } from './view';

export default LogTimeModalFooter;

export type { FormState } from './types';
